<div class="d-flex">
  <ui-select [uiBorderless]="true" [(ngModel)]="relatedItem.linkType" (ngModelChange)="onUpdateLinkOption()">
    <ui-option *ngFor="let linkOption of relatedLinkOptions" [uiValue]="linkOption.linkType" [uiLabel]="linkOption.label"></ui-option>
  </ui-select>
  <div class="hover-area align-items-c d-flex row-direction w-full">
    <ui-icon uiTheme="fill" uiType="{{ relatedItem.iconType }}" class="fs-20px pr-4px"></ui-icon>
    <!-- TODO: Set the corresponding width of goal name and avatars when the last are added-->
    <div id="related-item" (click)="openRelatedItem(relatedItem)">{{ relatedItem.name }}</div>
    <!-- TODO: Add avatars of the owners of related item -->
    <!-- TODO: Style close button using global close icon-->
    <ui-icon *ngIf="!hasViewOnlyRole" uiTheme="outline" uiType="close" class="close-icon" (click)="onDeleteItem()"></ui-icon>
  </div>
</div>
